module.exports = __webpack_public_path__ + "static/timechef-logo-659fda57715937dd4f505c4873721332.png";